import React from 'react';
import { default as RModal } from 'react-modal';
import styled from 'styled-components';
RModal.setAppElement('#root');
const ModalContent = styled.div`
    padding: 30px;
    max-width: 850px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: auto;
`;

const ModalHead = styled.div`
    width: 100%;
    height: 50px;
    background-color: #3700ff;
    display: flex;
    justify-content: flex-end;
    padding: 10px;
    cursor: pointer;
`;

const ModalTitle = styled.div`
    text-align: center;
    color: white;
    width: 100%;
`;
const CloseIcon = styled.div`
    position: absolute;
    right: 16px;
    top: 16px;
`;

const modalStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: '0px',
        maxHeight: 'calc(100vh - 210px)',
        minWidth: '300px',
    },
    overlay: {
        zIndex: 10,
    },
};

type Props = {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    children: React.ReactNode;
};

export const Modal: React.FC<Props> = ({ isOpen, onClose, title, children }: Props) => (
    <RModal isOpen={isOpen} onRequestClose={onClose} style={modalStyles} contentLabel="Example Modal">
        <>
            <ModalHead onClick={onClose}>
                <ModalTitle>{title}</ModalTitle>
                <CloseIcon>
                    <svg
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fas"
                        data-icon="times"
                        className="svg-inline--fa fa-times fa-w-11"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 352 512"
                        width="10"
                    >
                        <path
                            fill="#FFFFFF"
                            d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
                        ></path>
                    </svg>
                </CloseIcon>
            </ModalHead>
            <ModalContent>{children}</ModalContent>
        </>
    </RModal>
);

export default Modal;
